import { useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Info, ChevronDown } from "lucide-react";
import { formatKrWhole } from "../../lib/format";

const kr = (ore) => `${formatKrWhole(ore)} kr.`;
const pct = (v) => (v == null ? "—" : `${v} %`);

function Row({ label, value, sub, testid }) {
  return (
    <div className="crs-row" data-testid={testid}>
      <span>{label}</span>
      <b>{value}</b>
      {sub ? <small className="muted">{sub}</small> : null}
    </div>
  );
}

function Compare({ e }) {
  const diff = e.diff_pp == null ? null : `${e.diff_pp > 0 ? "+" : ""}${e.diff_pp} pct.-point`;
  return (
    <div className="crs-compare" data-testid="stats-cr-effect">
      <h3>Sammenligning <small className="muted">(kun afsluttede tilbud)</small></h3>
      <div className="crs-ab">
        <span data-testid="stats-cr-a">Påmindet: <b>{pct(e.a.rate)}</b> hentet (n={e.a.n})</span>
        <span data-testid="stats-cr-b">Ikke påmindet: <b>{pct(e.b.rate)}</b> hentet (n={e.b.n})</span>
        {diff && <span className="st-rem-diff" data-testid="stats-cr-diff">{diff}</span>}
      </div>
      {e.small && <small className="muted" data-testid="stats-cr-small">For få data endnu – tallene bliver mere sikre med tiden</small>}
      <div className="crs-extra" data-testid="stats-cr-extra">
        <span>
          Estimeret ekstra omsætning pga. påmindelser{" "}
          <span className="crs-info" tabIndex={0} title="Et skøn: forskellen i afhentningsprocent mellem påmindede og ikke-påmindede ordrer, ganget med værdien af de påmindede ordrer. Det er omsætning, der sandsynligvis ikke var blevet hentet uden påmindelsen." aria-label="Forklaring">
            <Info size={14} />
          </span>
        </span>
        {e.extra_ore == null ? <small className="muted">Kræver mindst 20 i hver gruppe</small> : <b data-testid="stats-cr-extra-value">{kr(e.extra_ore)}</b>}
      </div>
    </div>
  );
}

function OfferTable({ rows }) {
  const [open, setOpen] = useState(false);
  if (!rows.length) return null;
  return (
    <div className="crs-offers">
      <button type="button" className="crs-toggle" onClick={() => setOpen(!open)} aria-expanded={open} data-testid="stats-cr-offers-toggle">
        <ChevronDown size={16} style={{ transform: open ? "rotate(180deg)" : "none" }} /> {open ? "Skjul" : "Vis"} pr. tilbud ({rows.length})
      </button>
      {open && (
        <div className="crs-scroll" data-testid="stats-cr-offers">
          <table>
            <thead>
              <tr><th>Tilbud</th><th>Sendt</th><th>Hentet bagefter</th><th>Recover %</th><th>Hentet kr.</th><th>Afventer</th></tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.offer_id} data-testid={`stats-cr-offer-${r.offer_id}`}>
                  <td><Link to={`/offers/${r.offer_id}`}>{r.title}</Link></td>
                  <td>{r.sent}</td>
                  <td>{r.picked}</td>
                  <td>{pct(r.recover)}</td>
                  <td>{kr(r.picked_ore)}</td>
                  <td>{r.pending || "–"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default function StatsReminders({ r }) {
  if (!r || !(r.enabled || r.sent > 0)) return null;
  const t = r.totals;
  return (
    <section className="panel crs" data-testid="stats-comment-reminders">
      <h2><MessageCircle size={18} aria-hidden="true" /> Påmindelser i kommentaren</h2>
      <div className="crs-grid">
        <Row label="Sendt" value={`${t.sent} påmindelser`} testid="stats-cr-sent" />
        <Row label="Hentet efter påmindelse" value={`${t.picked} stk. · ${kr(t.picked_ore)}`} testid="stats-cr-picked" />
        <Row label="Recover-rate" value={pct(t.recover)} sub={t.pending ? `afventer ${t.pending}` : null} testid="stats-cr-recover" />
        <Row label="Ikke hentet trods påmindelse" value={`${t.missed} stk. · ${kr(t.missed_ore)}`} testid="stats-cr-missed" />
        <Row label="Afventer stadig" value={`${t.pending} stk. · ${kr(t.pending_ore)}`} sub="afhentning ikke slut" testid="stats-cr-pending" />
      </div>
      {r.effect && <Compare e={r.effect} />}
      <OfferTable rows={r.offers || []} />
    </section>
  );
}
